module.exports = __webpack_public_path__ + "img/start-playing-now.2ce048b3.png";